// extracted by mini-css-extract-plugin
module.exports = {"delta-pro-ultra-launch":"DPUHomeSolution_delta-pro-ultra-launch__hh3iz"};